import { findIndex } from 'lodash'
import { cookies } from './cookie'
import { ajax } from './http'
import { COOKIE_KEYS } from '@/constant/storage'

enum Municipality {
  BeiJin = '110000',
  TianJin = '120000',
  ShangHai = '310000',
  ChongQin = '500000'
}

const municipalityList = [
  Municipality.BeiJin,
  Municipality.ShangHai,
  Municipality.TianJin,
  Municipality.ChongQin
]

export interface CityType {
  cityId: string | number
  cityName: string
}

export const defaultCity: CityType = {
  cityId: '320100',
  cityName: '南京'
}

export function getCityId(cityId: string | number) {
  if (findIndex(municipalityList, o => o == cityId) > -1) {
    cityId = Number(cityId) + 100
  }
  return `${cityId}`
}

export async function getCityNameByCityId(cityId: string | number): Promise<string> {
  const response: any = await ajax.get(
    '//address.cekid.com/addressview/GetNameById',
    {
      params: {
        addressId: cityId
      }
    }
  )
  if (response && response.RetCode * 1 === 0) {
    return (response.Result && response.Result.NAME) || ''
  } else {
    return ''
  }
}

/* 从cookie获取选择城市 */
export async function getSelectedCity(): Promise<CityType | null> {
  let cityId = ''
  let cityName = ''
  const cookieCityService = cookies.get(COOKIE_KEYS.CITY_SERVICE)
  const cookieCityCode = cookies.get(COOKIE_KEYS.CITYCODE)
  if (cookieCityService) {
    const iNList = cookieCityService.split('_')
    cityId = iNList[0]
    cityName = decodeURIComponent(iNList[1])
  } else if (cookieCityCode) {
    cityId = cookieCityCode
    cityName = await getCityNameByCityId(cityId)
  }
  if (cityId && cityName) {
    cityId = getCityId(cityId)
    cityName = cityName.replace('市', '')
    return {
      cityId,
      cityName
    }
  } else {
    return null
  }
}

export async function getSelectedCityForCityService(): Promise<CityType | null> {
  let cityId = ''
  let cityName = ''
  const cookieCityService = cookies.get(COOKIE_KEYS.CITY_SERVICE)
  if (cookieCityService) {
    const iNList = cookieCityService.split('_')
    cityId = iNList[0]
    cityName = decodeURIComponent(iNList[1])
  }
  if (cityId && cityName) {
    cityId = getCityId(cityId)
    cityName = cityName.replace('市', '')
    return {
      cityId,
      cityName
    }
  } else {
    return null
  }
}

/* 从cookie获取选择城市  优先取city_service_set_in_h5字段 city_service_set_in_h5存在的意义是 在app里面无法真正切换city_service 在app切换city_service必须通过原生切换 */
export async function getSelectedCityInH5(): Promise<CityType | null> {
  let cityId = ''
  let cityName = ''
  const cookieCityServiceInh5 = cookies.get(COOKIE_KEYS.CITY_SERVICE_INH5)
  const cookieCityService = cookies.get(COOKIE_KEYS.CITY_SERVICE)
  const cookieCityCode = cookies.get(COOKIE_KEYS.CITYCODE)

  let iNListInH5: string[] = []
  if (cookieCityServiceInh5) {
    iNListInH5 = cookieCityServiceInh5.split('_')
  }
  if (iNListInH5.length >= 3) {
    cityId = iNListInH5[0]
    cityName = decodeURIComponent(iNListInH5[2])
  } else if (cookieCityService) {
    const iNList = cookieCityService.split('_')
    cityId = iNList[0]
    cityName = decodeURIComponent(iNList[1])
  } else if (cookieCityCode) {
    cityId = cookieCityCode
    cityName = await getCityNameByCityId(cityId)
  }
  if (cityId && cityName) {
    cityId = getCityId(cityId)
    cityName = cityName.replace('市', '')
    return {
      cityId,
      cityName
    }
  } else {
    return null
  }
}
